import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield } from 'lucide-react';

export default function ForgotPasswordPage() {
  const [form, setForm] = useState({ tenant_slug: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', form);
      setSent(true);
    } catch { toast.error('Fehler aufgetreten'); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 bg-primary rounded-sm flex items-center justify-center">
            <Shield className="w-4 h-4 text-primary-foreground" />
          </div>
          <span className="font-heading font-black text-xl tracking-tight">Your Hero</span>
        </div>
        {!sent ? (
          <>
            <h2 className="font-heading font-bold text-2xl mb-1">Passwort vergessen</h2>
            <p className="text-sm text-muted-foreground mb-6">Geben Sie Ihre Unternehmens-ID und E-Mail ein.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1.5"><Label>Unternehmens-ID</Label><Input value={form.tenant_slug} onChange={e => setForm(f => ({ ...f, tenant_slug: e.target.value }))} placeholder="ihr-unternehmen" className="rounded-sm" /></div>
              <div className="space-y-1.5"><Label>E-Mail</Label><Input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="name@unternehmen.ch" className="rounded-sm" /></div>
              <Button type="submit" className="w-full rounded-sm" disabled={loading}>{loading ? 'Senden...' : 'Reset-Link senden'}</Button>
            </form>
          </>
        ) : (
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-emerald-100 rounded-sm flex items-center justify-center mx-auto">
              <span className="text-3xl">✉️</span>
            </div>
            <h2 className="font-heading font-bold text-xl">E-Mail gesendet</h2>
            <p className="text-sm text-muted-foreground">Falls ein Konto existiert, wurde ein Reset-Link gesendet. Bitte prüfen Sie Ihr Postfach.</p>
            <Button onClick={() => window.location.href = '/login'} className="w-full rounded-sm">Zum Login</Button>
          </div>
        )}
        {!sent && <p className="mt-4 text-center text-sm"><Link to="/login" className="text-primary hover:underline">Zurück zum Login</Link></p>}
      </div>
    </div>
  );
}
